import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { getPersonFullName } from "utils/person";

export const getHorseShortInfoFromHorse = (
  horse: racehorse360.IHorse
): racehorse360.IHorseShortInfo => {
  if (!horse) return;

  return {
    id: horse.id,
    horseName: horse.name,
    horseRegistrationNumber: horse.registrationNumber,
    horseBirthday: horse.birthday,
    trainerName: getPersonFullName({
      firstName: horse.trainer?.firstName,
      lastName: horse.trainer?.lastName
    }),
    currentFacilityId: horse.currentFacility?.id
  };
};
